import { updateProject } from 'common/api/v1/projects';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_PROJECT,
    SAVE_PROJECT_FAILURE,
    SAVE_PROJECT_SUCCESS,
} from '../actionTypes';
import { projectsActions } from '../reducer';

export default (id, status, callback) => (dispatch) => {
    dispatch(projectsActions[SAVE_PROJECT]());

    updateProject({ status }, id)
        .then((response) => {
            dispatch(projectsActions[SAVE_PROJECT_SUCCESS](response.data));
            if (callback) callback();
            showToast();
        })
        .catch((error) => {
            dispatch(
                projectsActions[SAVE_PROJECT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
